export default __webpack_public_path__ + "static/media/bg2_m.e3d8a16c.png";